import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettingSubscription: React.FC<IconProps> = ({ width = 20, height = 20, color }) => {
    const strokeColor = color || '#7F7F7F';

    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_83590)">
                <path
                    d="M14.9305 8.8195C16.8055 6.9445 16.9227 4.71403 16.8641 3.7195C16.8543 3.56792 16.7897 3.42508 16.6823 3.31767C16.5749 3.21027 16.432 3.14565 16.2805 3.1359C15.2859 3.07731 13.057 3.19293 11.1805 5.0695L6.25 9.99996L10 13.75L14.9305 8.8195Z"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.624 5.625H5.80757C5.64203 5.62508 5.48329 5.69082 5.36617 5.80781L2.68257 8.49141C2.60064 8.57352 2.54317 8.67682 2.51661 8.78974C2.49004 8.90265 2.49543 9.02074 2.53216 9.13077C2.56889 9.2408 2.63552 9.33844 2.72459 9.41275C2.81366 9.48707 2.92165 9.53513 3.03648 9.55156L6.24898 10"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.375 9.375V14.1914C14.3749 14.3569 14.3092 14.5157 14.1922 14.6328L11.5086 17.3164C11.4265 17.3983 11.3232 17.4558 11.2103 17.4824C11.0973 17.5089 10.9793 17.5036 10.8692 17.4668C10.7592 17.4301 10.6616 17.3635 10.5872 17.2744C10.5129 17.1853 10.4649 17.0773 10.4484 16.9625L10 13.75"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M7.3875 14.6742C7.08516 15.3375 6.06641 16.8758 3.125 16.8758C3.125 13.9344 4.66328 12.9156 5.32656 12.6133"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_83590">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettingSubscription;
